import 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';

const cc = initCookieConsent();

fetch('/cookie-consent/options')
    .then((response) => response.json())
    .then((options) => {
        options.auto_language = 'document';
        options.autoclear_cookies = true;
        options.page_scripts = true;
        options.force_consent = true;
        options.use_rfc_cookie = true;
        options.gui_options = {
            consent_modal: {
                layout: 'bar',
                position: 'bottom center',
                transition: 'slide',
            },
            settings_modal: {
                layout: 'box',
                position: 'bottom center',
                transition: 'slide',
            },
        };
        const div = document.createElement('div');
        div.style.cssText = 'position:fixed;margin:5px;padding:0;bottom:0';
        div.innerHTML =
            '<button type="button" data-cc="c-settings"><i class="fas fa-cookie-bite" aria-hidden="true"></i></button>';
        document.body.appendChild(div);
        cc.run(options);
        div.firstElementChild.setAttribute(
            'aria-label',
            options.languages[cc.getConfig('current_lang')].settings_modal.title
        );
    });
